import script from "./modal-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./modal-dialog.vue?vue&type=script&lang=ts&setup=true"

const cssModules = {}
import style0 from "./modal-dialog.vue?vue&type=style&index=0&id=52707396&lang=scss&module=true"
cssModules["$style"] = style0
import "./modal-dialog.vue?vue&type=style&index=1&id=52707396&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules],['__scopeId',"data-v-52707396"]])

export default __exports__